import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function LinkedInIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>LinkedIn</title>;
    t3 = <path d="M4.51,4.41c-.22.21-.35.51-.35.82v13.71c0,.31.13.6.35.82.22.21.52.33.83.33h13.64c.31,0,.61-.11.83-.33s.35-.51.35-.82V5.23c0-.31-.13-.6-.35-.82-.22-.21-.52-.33-.83-.33H5.34c-.31,0-.61.11-.83.33ZM9.01,17.48v-7.22h-2.42v7.22h2.42ZM7.8,9.27c.17.02.35,0,.51-.06.16-.06.32-.15.44-.26.13-.12.23-.26.3-.42.07-.16.11-.33.11-.5,0-.17-.04-.34-.11-.5-.07-.16-.17-.3-.3-.42-.13-.12-.28-.21-.44-.26-.16-.06-.34-.08-.51-.07-.17-.02-.35,0-.51.06-.16.06-.32.15-.44.26-.13.12-.23.26-.3.42-.07.16-.11.33-.11.5,0,.17.03.34.1.5.07.16.17.3.29.42.13.12.27.21.44.26s.33.08.5.07h.02ZM10.35,17.48h2.42v-4.03c0-.2.02-.4.08-.59.09-.26.26-.48.48-.64.22-.16.49-.24.76-.24.87,0,1.22.66,1.22,1.63v3.87h2.42v-4.15c0-2.22-1.19-3.25-2.78-3.25-.44-.02-.88.09-1.27.3-.38.21-.69.52-.91.89v-1.02h-2.42c.03.68,0,7.17,0,7.22Z" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className || $[7] !== color || $[8] !== props) {
    t4 = <svg className={className} fill={color} fillRule="evenodd" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}</svg>;
    $[6] = className;
    $[7] = color;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function LinkedInWithBorderIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>LinkedIn</title>;
    t3 = <path d="M20 39.9777C9.44852 39.9777 0.864014 31.3932 0.864014 20.8417C0.864014 10.2903 9.44852 1.70178 20 1.70178C30.5514 1.70178 39.136 10.2863 39.136 20.8378C39.136 31.3892 30.5514 39.9737 20 39.9737V39.9777ZM20 3.29446C10.3245 3.29446 2.45271 11.1662 2.45271 20.8378C2.45271 30.5093 10.3245 38.3811 19.996 38.3811C29.6675 38.3811 37.5393 30.5093 37.5393 20.8378C37.5393 11.1662 29.6715 3.29446 20 3.29446Z" />;
    t4 = <path d="M15.3613 29.3028H11.5111V16.9118H15.3613V29.3028ZM13.4342 15.2235C12.2039 15.2235 11.2045 14.2042 11.2045 12.9739C11.2045 11.7435 12.2039 10.7441 13.4342 10.7441C14.6646 10.7441 15.664 11.7435 15.664 12.9739C15.664 14.2042 14.6646 15.2235 13.4342 15.2235ZM29.7631 29.3028H25.9208V23.2705C25.9208 21.8331 25.8929 19.9896 23.918 19.9896C21.9431 19.9896 21.6086 21.5504 21.6086 23.167V29.3028H17.7623V16.9118H21.4533V18.604H21.5091C22.0227 17.6285 23.2769 16.6012 25.1523 16.6012C29.0464 16.6012 29.7631 19.1654 29.7631 22.4981V29.3068H29.7591L29.7631 29.3028Z" />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== props) {
    t5 = <svg className={className} viewBox="0 0 40 41" xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}{t4}</svg>;
    $[7] = className;
    $[8] = props;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}